import React from 'react'
import PropTypes from 'prop-types'

const classNames = require('classnames')

const GlgLoadingOverlay = ({
  isLoading = false,
  children,
  overlayClassName,
  spinnerClassName,
}) => {
  return (
    <div className="glg-loading-overlay">
      {children}
      {isLoading && (
        <div className={classNames('overlay', overlayClassName)}>
          <div className={classNames('spinner', spinnerClassName)}></div>
        </div>
      )}
    </div>
  )
}

GlgLoadingOverlay.propTypes = {
  isLoading: PropTypes.bool,
  children: PropTypes.node.isRequired,
  overlayClassName: PropTypes.string,
  spinnerClassName: PropTypes.string,
}

export default GlgLoadingOverlay
